import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StyledButtonDisabled } from '../custom-styled-components/_MyCustomSC';
import { isDevENV } from '../../../util/isDevENV';
import "antd/dist/antd.css";
import {
  Button,
  Checkbox,
  InputNumber,
  Form,
  Radio,
  Input,
  Menu,
  Dropdown,
  Icon,
  Select,
  Row,
  Col,
  Tag
} from 'antd';

const InputGroup = Input.Group;

const { Option } = Select;

const SHOW_RULES = isDevENV() ? true : true; //for showing validation error, make it 'true'

const UnderlineText = ({ data, color }) => {
  const hrColor = color ? color : '#ffdfac';
  const hrStyle = {
    // borderColor: `${hrColor}`,
    height: '11px',
    border: 0,
    borderBottom: `1px solid ${hrColor}`,
    marginTop: '-6px',
  };
  return (
    <span
      style={{
        fontSize: '9px',
        width: '100%',
        height: '15px',
        fontWeight: 600,
        marginTop: '7px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className="testO1"
    >
      <span style={{ flex: '1', marginRight: '5px' }}>
        <hr style={{ ...hrStyle, borderTopLeftRadius: '0px', borderTopRightRadius: '0px', borderBottomRightRadius: '0px', borderBottomLeftRadius: '4px' }} />
      </span>
      <span style={{ color: hrColor }}>{data}</span>
      <span style={{ flex: '1', marginLeft: '5px' }}>
        <hr style={{ ...hrStyle, borderTopLeftRadius: '0px', borderTopRightRadius: '0px', borderBottomRightRadius: '4px', borderBottomLeftRadius: '0px' }} />
      </span>
    </span>
  );
};


/**
 * @component
 * @category Form Page
 * @subcategory LCL/AIR Tab
 * @name WrappedLeftRowShipping
 * @description It's the LCL/AIR shipping container component
 * <br> <br>
 * **Example**
 * ```js
 *   <WrappedLeftRowShipping rowId={2}/>
 * ```
 */
class WrappedLeftRowShipping extends Component {
  state = {
    hrGreyColor: '#8dabc4',
    hrBlueColor: '#0093ee',
    isWtInputFocused: false,
    isDimenInputFocused: false,

    packageType: 'box/crate',
    quantity: 1,

    dimenUnit: 'CM',

    dimenLeftValue: '',
    dimenLeftValueUnit: '',
    showDimenLeftValueUnit: false,

    dimenMidValue: '',
    dimenMidValueUnit: '',
    showDimenMidValueUnit: false,

    dimenRightValue: '',
    dimenRightValueUnit: '',
    showDimenRightValueUnit: false,

    wtUnit: 'KG',

    wtValue: '',
    wtValueUnit: '',
    showWtValueUnit: false,

    showPalletSelect: false,
    palletSideMenuValue: '',
    totalWeight: '',
    totalVolume: ''
  };

  /**
   * @description it updates load summary text
   * <br> <br>
   * **loadSummary() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  loadSummary = () => this.props.updateLoadSummaryLCL();

  // it initializes states of one single added load
  componentDidMount = () => {
    const { rowId } = this.props;
    if (this.props.boxPallet && !this.props.boxPallet[rowId]) {
      this.props.updateLclBoxPallet(this.props.rowId, {
        packageType: 'box/crate',
        quantity: 1,

        dimenUnit: 'CM',

        dimenLeftValue: '',
        dimenLeftValueUnit: '',
        showDimenLeftValueUnit: false,

        dimenMidValue: '',
        dimenMidValueUnit: '',
        showDimenMidValueUnit: false,

        dimenRightValue: '',
        dimenRightValueUnit: '',
        showDimenRightValueUnit: false,

        wtUnit: 'KG',

        wtValue: '',
        wtValueUnit: '',
        showWtValueUnit: false,
        totalWeight: '',
        totalVolume: ''
      });
    }
    this.loadSummary();
    //get states from redux and set to state
    if (this.props.boxPallet && this.props.boxPallet[rowId]) {
      this.setState(
        {
          ...this.props.boxPallet[rowId],
        },
        () => {
          //for rstoring UI state upon click on back/edit search btn
          // this.onFocus('dimen-left');
          // this.onFocus('dimen-mid');
          // this.onFocus('dimen-right');
          // this.onFocus('weight');

          this.onBlur('dimen-left');
          this.onBlur('dimen-mid');
          this.onBlur('dimen-right');
          this.onBlur('weight');
        }
      );
    }
  };

  componentWillUnmount = () => {
    this.loadSummary();
  };

  /**
   * @description it update values of dimensions' input fields when package type pallets is selected and dimension's dropdown option is changed
   * <br> <br>
   * **changeStateBasedOnMenu(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | key of selected dropdown option e.g. `0`, `1`, `2`, `3` |

   * Returns: Type: void
   */
  changeStateBasedOnMenu = (value) => {
    value = Number(value);
    // console.log("changeStateBasedOnMenu value typeof: ", typeof value);
    const { form } = this.props;
    form.setFieldsValue({ [`dimen-right-${this.props.rowId}`]: '' });
  
    if (value === 0) {
      this.setState(
        {
          dimenLeftValue: 48,
          dimenUnit: 'IN',
          wtUnit:'LB',
          dimenMidValue: 44,
          dimenRightValue: '',
          palletSideMenuValue: value,
          dimenRightValueUnit:'',
          totalVolume:'',
          totalWeight:''
        },
        () => {
          this.onBlur('weight');
          this.props.updateLclBoxPallet(this.props.rowId, {
            dimenLeftValue: 48,
            dimenUnit: 'IN',
            wtUnit:'LB',
            dimenMidValue: 44,
            dimenRightValue: '',
            dimenRightValueUnit:'',
            totalVolume:'',
            totalWeight:''
          });
          this.loadSummary();
        }
      );
    } else if (value === 1) {
      this.setState(
        {
          dimenLeftValue: 120,
          dimenUnit: 'CM',
          wtUnit:'KG',
          dimenMidValue: 80,
          dimenRightValue: '',
          palletSideMenuValue: value,
          dimenRightValueUnit: '',
        },
        () => {
          this.onBlur('weight')
          this.props.updateLclBoxPallet(this.props.rowId, {
            dimenLeftValue: 120,
            dimenUnit: 'CM',
            wtUnit:'KG',
            dimenMidValue: 80,
            dimenRightValue: '',
            dimenRightValueUnit:'',
          });
          this.loadSummary();
          
        }
      );
    } else if (value === 2) {
      this.setState(
        {
          dimenLeftValue: 120,
          dimenUnit: 'CM',
          wtUnit:'KG',
          dimenMidValue: 100,
          dimenRightValue: '',
          dimenRightValueUnit:'',
          palletSideMenuValue: value,
        },
        () => {
          this.props.updateLclBoxPallet(this.props.rowId, {
            dimenLeftValue: 120,
            dimenUnit: 'CM',
            wtUnit:'KG',
            dimenMidValue: 100,
            dimenRightValue: '',
            dimenRightValueUnit:'',
          });
          this.onBlur('weight')
          this.loadSummary();
          
        }
      );
    } else if (value === 3) {
      this.setState(
        {
          dimenLeftValue: '',
          dimenMidValue: '',
          dimenRightValue: '',
          palletSideMenuValue: value,
          dimenRightValueUnit:''
        },
        () => {
          this.props.updateLclBoxPallet(this.props.rowId, {
            dimenLeftValue: '',
            dimenLeftValueUnit: '',
            dimenMidValue: '',
            dimenMidValueUnit: '',
            dimenRightValue: '',
            dimenRightValueUnit: '',
          });
          this.loadSummary();
        }
      );
    }
  };

  /**
   * @description when package type pallets is selected and dimension's dropdown option is selected, this method is invoked
   * <br> <br>
   * **onDimenPalletSelectMenuChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | key of selected dropdown option e.g. `0`, `1`, `2`, `3` |

   * Returns: Type: void
   */
  onDimenPalletSelectMenuChange = (value) => {
    this.changeStateBasedOnMenu(value);
  };

  /**
   * @description when lcl/air shipping's # of Units input field changes, this method is invoked
   * <br> <br>
   * **onUnitInputNumChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | number        | # of Units input field value |

   * Returns: Type: void
   */
  onUnitInputNumChange = (value) => {
    this.setState({ quantity: value ? value : 1 }, () => {
      this.props.updateLclBoxPallet(this.props.rowId, {
        quantity: value ? value : 1,
        totalVolume: (parseFloat(this.calculateDimenVolume() * value).toFixed(2) || 0 ),
        totalWeight: (parseFloat(this.state.wtValue * value).toFixed(2) || 0)
      });
      this.loadSummary();
    });
  };

  /**
   * @description when lcl/air shipping's package type radio group is changed, this method is invoked
   * <br> <br>
   * **onPackageTypeChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | package type radio group onchange event |

   * Returns: Type: void
   */
  onPackageTypeChange = (e) => {
    // console.log("packg type: ", e.target.value);
    const showPalletSelect = e.target.value !== 'box/crate';
    this.setState(
      {
        dimenLeftValue: '',
        dimenMidValue: '',
        dimenRightValue: '',
        packageType: e.target.value,
        showPalletSelect,
        palletSideMenuValue: '',
      },
      () => {
        this.props.updateLclBoxPallet(this.props.rowId, {
          packageType: e.target.value,
          // dimenLeftValue: "",
          // dimenMidValue: "",
          // dimenRightValue: ""
        });
        this.loadSummary();
      }
    );
  };

  /**
   * @description it is invoked when radio groups of dimension's unit and weight's unit are changed.
   *
   * <br> <br>
   * **onRadioGroupChange(value, type) -> {void}**
   * <br><br>
   *  **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | value of selected radio e.g. `CM`, `IN`, `KG`, `LB`  |
   * | type          | string        | name of the radio group e.g. `dimen`, `weight` |
   *
   * Returns: Type: void
   */
  onRadioGroupChange = (value, type) => {
    if (type === 'dimen') {
      this.setState({ dimenUnit: value }, () => {
        if(value === 'CM'){
          this.props.updateLclBoxPallet(this.props.rowId, { dimenUnit: value, wtUnit: 'KG',
          totalVolume: (parseFloat(this.calculateDimenVolume() * this.state.quantity).toFixed(2) || 0 ),
          totalWeight: (parseFloat(this.state.wtValue * this.state.quantity).toFixed(2) || 0) });
          this.setState({ wtUnit: 'KG' }, () => {
            this.onBlur('weight');
          });
        }else if(value === 'IN'){
          this.props.updateLclBoxPallet(this.props.rowId, { dimenUnit: value, wtUnit: 'LB',
          totalVolume: (parseFloat(this.calculateDimenVolume() * this.state.quantity).toFixed(2) || 0 ),
          totalWeight: (parseFloat(this.state.wtValue * this.state.quantity).toFixed(2) || 0) }); 
          //this.setState({wtUnit: 'LB'})
          this.setState({ wtUnit: 'LB' }, () => {
            this.onBlur('weight');
          });
        }
       
        this.onBlur('dimen-left');
        this.onBlur('dimen-mid');
        this.onBlur('dimen-right');
        this.loadSummary();
      });
    } else if (type === 'weight') {
      this.setState({ wtUnit: value }, () => {
        if(value === 'KG'){
          this.props.updateLclBoxPallet(this.props.rowId, { wtUnit: value, dimenUnit: 'CM', totalVolume: (parseFloat(this.calculateDimenVolume() * this.state.quantity).toFixed(2) || 0 ),
          totalWeight: (parseFloat(this.state.wtValue * this.state.quantity).toFixed(2) || 0) });
          this.setState({ dimenUnit: 'CM' }, () => {
            this.onBlur('dimen-left');
            this.onBlur('dimen-mid');
            this.onBlur('dimen-right');
          });
        } else if(value === 'LB'){
          this.props.updateLclBoxPallet(this.props.rowId, { wtUnit: value, dimenUnit: 'IN',
          totalVolume: (parseFloat(this.calculateDimenVolume() * this.state.quantity).toFixed(2) || 0 ),
          totalWeight: (parseFloat(this.state.wtValue * this.state.quantity).toFixed(2) || 0) });
          this.setState({ dimenUnit: 'IN' }, () => {
            this.onBlur('dimen-left');
            this.onBlur('dimen-mid');
            this.onBlur('dimen-right');
          });
        }
        this.onBlur('weight');
        this.loadSummary();
      });
    }
  };

  /**
   * @description it validates input fields, it will show error e.g. `minimum is 0.4 CM` under input fields
   * <br> <br>
   * **validateMyInput(inputName) -> {void}**
   * <br><br>
   *  **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | inputName     | string        | input field name e.g. `dimen-left`  |
   *
   * Returns: Type: void
   */
  validateMyInput = (inputName) => {
    const { rowId } = this.props;
    inputName = `${inputName}-${rowId}`;
    this.props.form.validateFields([inputName], { force: true });
  };

  /**
   * @description it is invoked when input fields 
   * i.e. dimensions' left, mid, right and weight's are on blur state
   * <br> <br>
   * **onChange(value, type) -> {string | number}**
   * <br><br>
   *  **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | value of input field, it only accepts numeric key press  |
   * | type          | string        | name of the input fields e.g. `dimen-left`, `weight` |

   * **Example**
   * ```js
   *   console.log(onChange(value, type)) //8
   * ```
   * Returns: Type: string | number
   */
  onChange = (value, type) => {
    const {
      wtValue,
      quantity,
      dimenLeftValue,
      dimenMidValue,
      dimenRightValue,
    } = this.state;

    let stateValue;
    let valueKey;

    if (type === 'weight') {
      stateValue = wtValue;
      valueKey = 'wtValue';
    } else if (type === 'dimen-left') {
      stateValue = dimenLeftValue;
      valueKey = 'dimenLeftValue';
    } else if (type === 'dimen-mid') {
      stateValue = dimenMidValue;
      valueKey = 'dimenMidValue';
    } else if (type === 'dimen-right') {
      stateValue = dimenRightValue;
      valueKey = 'dimenRightValue';
    } else {
      return;
    }

    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      this.setState({ [valueKey]: parseFloat(value) }, () => {
      // Define the payload object to be passed to updateLclBoxPallet
        const payload = {
          [valueKey]: parseFloat(value),
          totalVolume: (parseFloat(this.calculateDimenVolume() * quantity).toFixed(2) || 0 ),
        };

        // If the type is 'weight', calculate total weight and add it to the payload
        if (type === 'weight') {
          payload.totalWeight = parseFloat(value * quantity).toFixed(2) || 0;
        }
        this.props.updateLclBoxPallet(this.props.rowId,payload)
        this.loadSummary();
      });

      return value;
    } else {
      return isNaN(stateValue) ? '' : stateValue;
    }
  };

  /**
   * @description it is invoked when input fields 
   * i.e. dimensions' left, mid, right and weight's are on blur state
   * <br> <br>
   * **onBlur(type) -> {void}**
   * <br><br>
   *  **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | type          | string        | name of the input fields e.g. `dimen-left`, `weight` |

   * Returns: Type: void
   */
  onBlur = (type) => {
    const {
      wtValue,
      quantity,
      wtUnit,
      dimenLeftValue,
      dimenMidValue,
      dimenRightValue,
      dimenUnit,
    } = this.state;

    let showValueKey;
    let valueUnitKey;
    let value;
    let unit;

    if (type === 'weight') {
      this.setState({ isWtInputFocused: false });
    } else {
      this.setState({ isDimenInputFocused: false });
    }

    if (type === 'weight') {
      showValueKey = 'showWtValueUnit';
      valueUnitKey = 'wtValueUnit';
      value = wtValue;
      unit = wtUnit;
    } else if (type === 'dimen-left') {
      showValueKey = 'showDimenLeftValueUnit';
      valueUnitKey = 'dimenLeftValueUnit';
      value = dimenLeftValue;
      unit = dimenUnit;
    } else if (type === 'dimen-mid') {
      showValueKey = 'showDimenMidValueUnit';
      valueUnitKey = 'dimenMidValueUnit';
      value = dimenMidValue;
      unit = dimenUnit;
    } else if (type === 'dimen-right') {
      showValueKey = 'showDimenRightValueUnit';
      valueUnitKey = 'dimenRightValueUnit';
      value = dimenRightValue;
      unit = dimenUnit;
    } else {
      return;
    }

    let check = false;
    if (value === 0) {
      check = true;
    } else {
      check = value;
    }
    const { rowId } = this.props;

    check &&
      showValueKey &&
      valueUnitKey &&
      this.setState(
        {
          [showValueKey]: true,
          [valueUnitKey]: `${value} ${unit}`,
        },
        () => {
          // Define the payload object to be passed to updateLclBoxPallet
          const payload = {
            [showValueKey]: true,
            [valueUnitKey]: `${value} ${unit}`,
            totalVolume: (parseFloat(this.calculateDimenVolume() * quantity).toFixed(2) || 0 ),
          };
  
          // If the type is 'weight', calculate total weight and add it to the payload
          if (type === 'weight') {
            payload.totalWeight = parseFloat(wtValue * quantity).toFixed(2) || 0;
          }
          this.props.updateLclBoxPallet(this.props.rowId,payload)
          this.loadSummary();

          this.props.form.setFieldsValue({
            [`${type}-${rowId}`]: `${value} ${unit}`,
          });
          this.validateMyInput(type);
        }
      );
  };

  /**
   * @description it is invoked when input fields 
   * i.e. dimensions' left, mid, right and weight's are on focus state
   * <br> <br>
   * **onFocus(type) -> {void}**
   * <br><br>
   *  **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | type          | string        | name of the input fields e.g. `dimen-left`, `weight` |

   * Returns: Type: void
   */
  onFocus = (type) => {
    const { wtValue, wtUnit, quantity, dimenLeftValue, dimenMidValue, dimenRightValue } =
      this.state;

    let showValueKey;
    let valueUnitKey;
    let value;
    let unit;

    if (type === 'weight') {
      this.setState({ isWtInputFocused: true });
    } else {
      this.setState({ isDimenInputFocused: true });
    }

    if (type === 'weight') {
      showValueKey = 'showWtValueUnit';
      valueUnitKey = 'wtValueUnit';
      value = wtValue;
      unit = wtUnit;
    } else if (type === 'dimen-left') {
      showValueKey = 'showDimenLeftValueUnit';
      valueUnitKey = 'dimenLeftValueUnit';
      value = dimenLeftValue;
    } else if (type === 'dimen-mid') {
      showValueKey = 'showDimenMidValueUnit';
      valueUnitKey = 'dimenMidValueUnit';
      value = dimenMidValue;
    } else if (type === 'dimen-right') {
      showValueKey = 'showDimenRightValueUnit';
      valueUnitKey = 'dimenRightValueUnit';
      value = dimenRightValue;
    } else {
      return;
    }

    let check = false;
    if (value === 0) {
      check = true;
    } else {
      check = value;
    }
    const { rowId } = this.props;
    check &&
      showValueKey &&
      valueUnitKey &&
      this.setState(
        {
          [showValueKey]: false,
          [valueUnitKey]: '',
        },
        () => {
          // Define the payload object to be passed to updateLclBoxPallet
          const payload = {
            [showValueKey]: false,
            [valueUnitKey]: '',
            totalVolume: (parseFloat(this.calculateDimenVolume() * quantity).toFixed(2) || 0 ),
          };
  
          // If the type is 'weight', calculate total weight and add it to the payload
          if (type === 'weight') {
            payload.totalWeight = parseFloat(wtValue * quantity).toFixed(2) || 0;
          }
          this.props.updateLclBoxPallet(this.props.rowId,payload)

          this.loadSummary();
          this.props.form.setFieldsValue({
            [`${type}-${rowId}`]: `${value}`,
          });
        }
      );
    this.validateMyInput(type);
  };

  /**
   * @description it calculates dimensions volume
   * <br> <br>
   * **calculateDimenVolume() -> {string}**
   * <br><br>
   *  * **Example**
   * ```js
   *   console.log(calculateDimenVolume()) //0.29
   * ```
   * Returns: Type: void
   */
  calculateDimenVolume = () => {
    const { dimenUnit, dimenLeftValue, dimenMidValue, dimenRightValue } =
      this.state;

    let tempVal =
      (dimenLeftValue || 0) * (dimenMidValue || 0) * (dimenRightValue || 0);

    if (dimenUnit === 'CM') {
      //Cubic Metres(CBM)
      tempVal = parseFloat(tempVal / 1000000).toFixed(2);
    } else {
      //Cubic Feet(CFT)
      tempVal = parseFloat(tempVal / 1728).toFixed(2);
    }

    return tempVal;
  };

  render() {
    const {
      dimenUnit,
      wtUnit,
      hrGreyColor,
      hrBlueColor,
      quantity,
      packageType,
      isWtInputFocused,
      isDimenInputFocused,
      showPalletSelect,
      palletSideMenuValue,
      dimenLeftValue,
      dimenMidValue,
      dimenRightValue,
      wtValue,
    } = this.state;
    const { getFieldDecorator, getFieldsError } = this.props.form;

    // console.log(
    //   "rowId: ",
    //   this.props.rowId,
    //   "boxPallet: ",
    //   this.props.boxPallet
    // );

    //min. 2 CM or 1.2 CM or 0.4 CM or 0.5
    const patternLeft =
      /^(([1-9][0-9]*(\.[0-9]*)?)|(0\.[4-9]*))(\s*[A-Za-z]*)?$/;
    // min is 0.1
    // const patternLeft2 = /^0\.[1-9]/;

    // greater than zero i.e. 1, 0.1, 0.00001
    // const patternLeft1 = /^([1-9]{1,}[0-9]*|0\.[0]*[1-9]+)/;

    const inputErrMessage = 'minimum is 0.4';

    const menu = (
      <Menu onClick={(e) => this.onDimenPalletSelectMenuChange(e.key)}>
        <Menu.Item key="0">48" x 44"</Menu.Item>
        <Menu.Item key="1">120 x 80 cm (Euro1)</Menu.Item>
        <Menu.Item key="2">120 x 100 cm (Euro2)</Menu.Item>
        <Menu.Item key="3">Other</Menu.Item>
      </Menu>
    );

    const { rowId } = this.props;

    return (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Row className="custom-row">
          <Col style={{marginTop:'0.4rem'}}>
          <div
            className="testR1"
            style={{ maxWidth: '245px', height: '100%', padding: '4px' }}
          >
            <div
              style={{
                fontSize: '11px',
                color: '#717585',
                width: '100%',
                height: '17px',
                fontWeight: 600,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <span> Package Type</span>
            </div>
            <div style={{ width: '100%' }} className="testR1">
              <Radio.Group
                // defaultValue="a"
                value={packageType}
                size="large"
                style={{ width: '200px' }}
                onChange={this.onPackageTypeChange}
              >
                <Radio.Button
                  value="box/crate"
                  style={{ fontSize: '13px', width: '60%' }}
                >
                  Boxes/Crates
                </Radio.Button>
                <Radio.Button
                  value="pallet"
                  style={{ fontSize: '13px', width: '40%' }}
                >
                  Pallets
                </Radio.Button>
              </Radio.Group>
            </div>
          </div>
        </Col>
          {/* # of Units */}
        <Col style={{marginTop:'0.4rem'}}>
          <div
            className="testO1"
            style={{ maxWidth: '100px', height: '100%', padding: '4px'}}
          >
            <div
              style={{
                fontSize: '11px',
                width: '100%',
                height: '17px',
                fontWeight: 600,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
              className="testR1"
            >
              <span># of Units</span>
            </div>
            <div>
              <InputNumber
                min={1}
                // max={10}
                // defaultValue={3}
                value={quantity}
                onChange={this.onUnitInputNumChange}
                style={{ width: '100%', height: '38px' }}
              />
            </div>
          </div>
        </Col>
        <Col> 
          {/* Dimensions */}
          <div
            style={{
              //maxWidth: '334px',
              // width: '314px',
              height: '100%',
              padding: '4px',
            }}
            className="testBla1 custom-dimension-box"
          >
            <span
              style={{
                fontSize: '11px',
                width: '100%',
                height: '17px',
                fontWeight: 600,
              }}
              className="testR1"
            >
              <span>Dimensions: </span>
              <span className="my-radio-btns">
                <Radio.Group
                  defaultValue="CM"
                  value={dimenUnit || undefined}
                  size="small"
                  style={{}}
                  onChange={(e) =>
                    this.onRadioGroupChange(e.target.value, 'dimen')
                  }
                >
                  <Radio.Button
                    value="CM"
                    style={{ fontSize: '11px', width: '35px', height: '17px' }}
                  >
                    CM
                  </Radio.Button>
                  <Radio.Button
                    value="IN"
                    style={{ fontSize: '11px', width: '35px', height: '17px' }}
                  >
                    IN
                  </Radio.Button>
                </Radio.Group>
              </span>
            </span>
            <div
              style={{
                height: '41px',
                minWidth: '250px',
                padding: '2px',
                marginBottom: '10px',
              }}
              className="testR1"
            >
              {!showPalletSelect ? (
                <InputGroup
                  compact
                  size="large"
                  style={{
                    height: 'auto',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                  }}
                  className="testR1"
                >
                  <span
                    className="testR1"
                    style={{ width: '33.33%', 
                    fontSize: '5px' }}
                  >
                    <Form.Item style={{ width: '100%' }}>
                      {getFieldDecorator(`dimen-left-${rowId}`, {
                        getValueFromEvent: (e) =>
                          this.onChange(e.target.value, 'dimen-left'),
                        rules: [
                          { required: SHOW_RULES, message: 'Required' },
                          {
                            pattern: patternLeft,
                            message: `${inputErrMessage} ${dimenUnit}`,
                          },
                        ],
                      })(
                        <Input
                          placeholder="L"
                          name="L"
                          onBlur={() => this.onBlur('dimen-left')}
                          onFocus={() => this.onFocus('dimen-left')}
                          className="testR1"
                          autoComplete="off"
                        />
                      )}
                    </Form.Item>
                  </span>

                  <span
                    className="testR1"
                    style={{ width: '33.33%', fontSize: '5px' }}
                  >
                    <Form.Item style={{ width: '100%' }}>
                      {getFieldDecorator(`dimen-mid-${rowId}`, {
                        getValueFromEvent: (e) =>
                          this.onChange(e.target.value, 'dimen-mid'),
                        rules: [
                          { required: SHOW_RULES, message: 'Required' },
                          {
                            pattern: patternLeft,
                            message: `${inputErrMessage} ${dimenUnit}`,
                          },
                        ],
                      })(
                        <Input
                          placeholder="W"
                          name="W"
                          onBlur={() => this.onBlur('dimen-mid')}
                          onFocus={() => this.onFocus('dimen-mid')}
                          autoComplete="off"
                        />
                      )}
                    </Form.Item>
                  </span>

                  <span
                    className="testR1"
                    style={{ width: '33.33%', 
                    fontSize: '5px' }}
                  >
                    <Form.Item style={{ width: '100%' }}>
                      {getFieldDecorator(`dimen-right-${rowId}`, {
                        getValueFromEvent: (e) =>
                          this.onChange(e.target.value, 'dimen-right'),
                        rules: [
                          { required: SHOW_RULES, message: 'Required' },
                          {
                            pattern: patternLeft,
                            message: `${inputErrMessage} ${dimenUnit}`,
                          },
                        ],
                      })(
                        <Input
                          placeholder="H"
                          name="H"
                          onBlur={() => this.onBlur('dimen-right')}
                          onFocus={() => this.onFocus('dimen-right')}
                          autoComplete="off"
                        />
                      )}
                    </Form.Item>
                  </span>
                </InputGroup>
              ) : (
                <div>
                  {palletSideMenuValue === 0 || palletSideMenuValue > 0 ? (
                    <InputGroup
                      compact
                      size="large"
                      style={{
                        height: 'auto',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'start',
                      }}
                      className="testR1"
                    >
                      <span
                        className="testR1"
                        style={{ width: '30%', 
                        fontSize: '5px' }}
                      >
                        {!dimenLeftValue || palletSideMenuValue === 3 ? (
                          <Form.Item style={{ width: '100%' }}>
                            {getFieldDecorator(`dimen-left-${rowId}`, {
                              getValueFromEvent: (e) =>
                                this.onChange(e.target.value, 'dimen-left'),
                              rules: [
                                { required: SHOW_RULES, message: 'Required' },
                                {
                                  pattern: patternLeft,
                                  message: `${inputErrMessage} ${dimenUnit}`,
                                },
                              ],
                            })(
                              <Input
                                placeholder="L"
                                name="L"
                                onBlur={() => this.onBlur('dimen-left')}
                                onFocus={() => this.onFocus('dimen-left')}
                                className="testR1"
                              />
                            )}
                          </Form.Item>
                        ) : (
                          <Input
                            placeholder="L"
                            name="L"
                            className="testR1"
                            value={dimenLeftValue}
                          />
                        )}
                      </span>

                      <span
                        className="testR1"
                        style={{ width: '30%', 
                        fontSize: '5px' }}
                      >
                        {!dimenMidValue || palletSideMenuValue === 3 ? (
                          <Form.Item style={{ width: '100%' }}>
                            {getFieldDecorator(`dimen-mid-${rowId}`, {
                              getValueFromEvent: (e) =>
                                this.onChange(e.target.value, 'dimen-mid'),
                              rules: [
                                { required: SHOW_RULES, message: 'Required' },
                                {
                                  pattern: patternLeft,
                                  message: `${inputErrMessage} ${dimenUnit}`,
                                },
                              ],
                            })(
                              <Input
                                placeholder="W"
                                name="W"
                                onBlur={() => this.onBlur('dimen-mid')}
                                onFocus={() => this.onFocus('dimen-mid')}
                              />
                            )}
                          </Form.Item>
                        ) : (
                          <Input
                            placeholder="W"
                            name="W"
                            value={dimenMidValue}
                          />
                        )}
                      </span>

                      <span
                        className="testR1"
                        style={{ width: '30%', 
                        fontSize: '5px' }}
                      >
                        <Form.Item style={{ width: '100%' }}>
                          {getFieldDecorator(`dimen-right-${rowId}`, {
                            getValueFromEvent: (e) =>
                              this.onChange(e.target.value, 'dimen-right'),
                            rules: [
                              { required: SHOW_RULES, message: 'Required' },
                              {
                                pattern: patternLeft,
                                message: `${inputErrMessage} ${dimenUnit}`,
                              },
                            ],
                          })(
                            <Input
                              placeholder="H"
                              name="H"
                              onBlur={() => this.onBlur('dimen-right')}
                              onFocus={() => this.onFocus('dimen-right')}
                              autoComplete="off"
                            />
                          )}
                        </Form.Item>
                      </span>

                      <Dropdown
                        overlay={menu}
                        trigger={['click']}
                        className="testR2"
                      >
                        <span
                          style={{
                            width: '10%',
                            height: '40px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                            background: '#bbc',
                          }}
                        >
                          <Icon type="down" />
                        </span>
                      </Dropdown>
                    </InputGroup>
                  ) : (
                    <div
                      style={{
                        width:'100%',
                        height: 'auto',
                      }}
                      className="custom-pallet-select"
                    >
                      <Select
                        placeholder="Pallet Type"
                        onChange={this.onDimenPalletSelectMenuChange}
                        style={{}}
                      >
                        <Option value="0" key={`0`}>
                          48" x 44"
                        </Option>
                        <Option value="1" key={`1`}>
                          120 x 80 cm (Euro1)
                        </Option>
                        <Option value="2" key={`2`}>
                          120 x 100 cm (Euro2)
                        </Option>
                        <Option value="3" key={`3`}>
                          Other
                        </Option>
                      </Select>
                    </div>
                  )}
                </div>
              )}
            </div>
            <UnderlineText
              style={{ width: '100%' }}
              data={
                packageType === 'box/crate' ? 'PER BOX/CRATE' : 'PER PALLET'
              }
              color={isDimenInputFocused ? hrBlueColor : hrGreyColor}
            />
          </div>
          </Col>
          {/* Weights */}
          <Col>
          <div
            className="testR1"
            style={{
              maxWidth: '140px',
              height: '100%',
              padding: '4px',
            }}
          >
            <span
              style={{
                fontSize: '11px',
                width: '100%',
                height: '17px',
                fontWeight: 600,
              }}
              className="testO1"
            >
              <span>Weights: </span>
              <span className="my-radio-btns">
                <Radio.Group
                  defaultValue="KG"
                  value={wtUnit || undefined}
                  size="small"
                  className="testO1"
                  onChange={(e) =>
                    this.onRadioGroupChange(e.target.value, 'weight')
                  }
                >
                  <Radio.Button
                    value="KG"
                    style={{ fontSize: '11px', width: '35px', height: '17px' }}
                  >
                    KG
                  </Radio.Button>
                  <Radio.Button
                    value="LB"
                    style={{ fontSize: '11px', width: '35px', height: '17px' }}
                  >
                    LB
                  </Radio.Button>
                </Radio.Group>
              </span>
            </span>
            <div
              style={{
                height: '52px',
                width: '100%',
                padding: '2px',
                marginBottom: '-4px',
              }}
              className="testO1"
            >
              <span
                className="testR1"
                style={{
                  width: '100%',
                  height: '100%',
                  fontSize: '5px',
                }}
              >
                <Form.Item style={{ width: '100%' }}>
                  {getFieldDecorator(`weight-${rowId}`, {
                    getValueFromEvent: (e) =>
                      this.onChange(e.target.value, 'weight'),
                    rules: [
                      { required: SHOW_RULES, message: 'Required' },
                      {
                        pattern: patternLeft,
                        message: `${inputErrMessage} ${wtUnit}`,
                      },
                    ],
                  })(
                    <Input
                      placeholder="Unit"
                      name="L"
                      onBlur={() => this.onBlur('weight')}
                      onFocus={() => this.onFocus('weight')}
                      className="testR1"
                      style={{ height: '38px' }}
                      autoComplete="off"
                    />
                  )}
                </Form.Item>
              </span>
            </div>
            <UnderlineText
              style={{ width: '100%' }}
              data={
                packageType === 'box/crate' ? 'PER BOX/CRATE' : 'PER PALLET'
              }
              color={isWtInputFocused ? hrBlueColor : hrGreyColor}
              className="testR"
            />
          </div>
          </Col>
          </Row>
          {/* Far right summary */}  
          <Col>
          <div
            className="testO1"
            style={{
              // maxWidth: '75px',
              padding: '6px',
              paddingLeft: '0px',
              height: '100%',
            }}
          >
            <div
              style={{
                height: '90px',
                width: '100%',
                fontSize: '10px',
                fontWeight: '600',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
              className="testR1"
            >
              <span style={{ height: '33%' }}>{quantity}&nbsp;Unit</span>
              <span style={{ height: '33%' }}>
                {parseFloat(this.calculateDimenVolume() * quantity).toFixed(
                  2
                ) || 0}
                &nbsp;
                {dimenUnit === 'CM' ? 'CBM' : 'CFT'}
              </span>
              <span style={{ height: '33%' }}>
                {/* {parseFloat(wtValue * quantity).toFixed(2) || 0}&nbsp;{wtUnit} */}
                {(wtValue ? parseFloat(wtValue * quantity).toFixed(2) : '') || 0}&nbsp;{wtUnit}
              </span>
            </div>
          </div>
          </Col>
          </div>
        {/* </Form> */}
      </>
    );
  }
}

const LeftRowShipping = Form.create({ name: 'search_form' })(
  WrappedLeftRowShipping
);

WrappedLeftRowShipping.propTypes = {
  /**
   * lcl box/pallet data
   */
  boxPallet: PropTypes.object,
  /**
   * single added load `id`
   */
  rowId: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    // isFclTabActive: state.form.isFclTabActive,
    boxPallet: state.form.lclAirShipping.boxPallet,
    lclShipment: state.code_config.lclShipment,
  };
};

export default connect(mapStateToProps, actions)(LeftRowShipping);
